// Vollea — Beta Feedback
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack, IoSendOutline } from "react-icons/io5";
import { Btn, Pill } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP, R } from "../lib/theme";

const CATS = [
  { value: "general", label: "General" },
  { value: "bug", label: "Bug" },
  { value: "idea", label: "Idea" },
];

export default function Feedback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [category, setCategory] = useState("general");
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!message.trim()) return;
    setSubmitting(true); setMsg("");
    try {
      await api.post("/feedback", { message, category });
      setMsg("Thanks for the feedback!");
      setMessage("");
    } catch (e) { setMsg(e.message); }
    finally { setSubmitting(false); }
  };

  return (
    <form onSubmit={submit} style={{ background: C.bg, minHeight: "100vh", padding: `${SP.lg}px ${SP.lg}px 90px` }}>
      <button type="button" onClick={() => navigate(-1)} data-testid="feedback-back" style={{ color: C.text, marginBottom: SP.md }}>
        <IoChevronBack size={26} />
      </button>
      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 28, margin: 0, letterSpacing: 0.5 }}>Beta Feedback</h1>
      <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4, marginBottom: SP.xl }}>Spotted a bug or have an idea? Tell us anything.</p>

      <div style={{ color: C.textMuted, fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: SP.sm, textTransform: "uppercase" }}>Category</div>
      <div style={{ display: "flex", gap: SP.sm, marginBottom: SP.xl }}>
        {CATS.map((c) => (
          <Pill key={c.value} label={c.label} active={category === c.value} onClick={() => setCategory(c.value)} testid={`feedback-cat-${c.value}`} />
        ))}
      </div>

      <div style={{ color: C.textMuted, fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: SP.sm, textTransform: "uppercase" }}>Message</div>
      <textarea
        data-testid="feedback-message-input"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={6}
        placeholder="What's on your mind?"
        style={{
          width: "100%", background: C.surface, color: C.text, padding: SP.lg,
          border: `1px solid ${C.border}`, borderRadius: R.md, fontSize: 15, outline: "none",
          fontFamily: "inherit", resize: "vertical", minHeight: 140,
        }}
        required
      />

      {msg ? <p data-testid="feedback-msg" style={{ color: msg.startsWith("Thanks") ? C.lime : C.error, marginTop: SP.md, fontSize: 13 }}>{msg}</p> : null}

      <div style={{ height: SP.lg }} />
      <Btn label="Send feedback" icon={<IoSendOutline size={16} />} loading={submitting} testid="feedback-submit-button" type="submit" onClick={submit} />
    </form>
  );
}
